import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import variables from 'src/style/variables.json'
import styled, { css } from 'styled-components'

export enum TagColorSchemes {
  Red = 'Red',
  Blue = 'Blue',
  Green = 'Green',
  Yellow = 'Yellow',
  Default = 'Default',
}

interface TagProps {
  className?: string
  text: React.ReactNode | string
  color?: TagColorSchemes
  fontSize?: number
  testId?: string
}

interface StyledContainerProps {
  textColor: string
  backgroundColor: string
}

const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: fit-content;
  border-radius: 5px;
  padding: 0 4px;
  background-color: ${({ backgroundColor }): string => backgroundColor};
`

const getTagColorScheme = (
  colorScheme: TagColorSchemes,
): { backgroundColor: string; textColor: string } => {
  switch (colorScheme) {
    case TagColorSchemes.Red:
      return {
        backgroundColor: variables.tokensColor.red50,
        textColor: variables.tokensColor.red100,
      }
    case TagColorSchemes.Blue:
      return {
        backgroundColor: variables.tokensColor.blue100,
        textColor: variables.tokensColor.blue400,
      }
    case TagColorSchemes.Green:
      return {
        backgroundColor: variables.tokensColor.green50,
        textColor: variables.tokensColor.green500,
      }
    case TagColorSchemes.Yellow:
      return {
        backgroundColor: variables.tokensColor.yellow50,
        textColor: variables.tokensColor.yellow800,
      }
    case TagColorSchemes.Default:
    default:
      return {
        backgroundColor: variables.tokensColor.grey400,
        textColor: variables.tokensColor.grey800,
      }
  }
}

const Tag: React.FC<TagProps> = (props): React.ReactElement => {
  const color = getTagColorScheme(props?.color || TagColorSchemes.Default)
  return (
    <StyledContainer
      textColor={color.textColor}
      backgroundColor={color.backgroundColor}
      data-testid={props.testId}
      css={css`
        ${getFontCss(
          props?.fontSize || 12,
          color.textColor,
          styleConstants.fontFamilies.medium,
        )};
      `}
    >
      {props.text}
    </StyledContainer>
  )
}

export default Tag
